const ImageAssets = {
  Name: require('./resources/name.webp'),
  Logo: require('./resources/logo.webp'),
  Thumbnail: require('./resources/thumbnail.webp'),
  Background: require('./resources/background.webp'),
  CircleLogo: require('./resources/circle-logo.webp'),
  Promotion: require('./resources/promotion.webp'),
  Maintenance: require('./resources/maintain.webp'),
  Jackpot: require('./resources/jackpot.webp'),
  Sphere: require('./resources/sphere.png'),
  RandomGif: require('./resources/random.gif'),
  WaitingGit: require('./resources/waiting.gif'),
  Stick: require('./resources/stick.png'),
  Ball: require('./resources/ball.png'),
  Counting: require('./resources/counting.jpeg'),
  Dragon: require('./resources/dragon.png'),
  GuideBet: require('./resources/guide-bet.png'),
  GuideResult: require('./resources/guide-result.png'),
  WinnerGif: require('./resources/winner.gif'),
  DragonGif: require('./resources/dragon.gif'),
  JackpotWinner: require('./resources/jackpot_winner.webp'),
  Page404: require('./resources/page-404.webp'),
  littleDragon: require('./resources/little-dragon.webp'),
  littleDragonSmile: require('./resources/little-dragon-smile.webp'),
  bgCasino: require('./resources/bg-casino.webp'),
  MassiveGlod: require('./resources/slot/massive-gold.png'),
  BreakAwayMax: require('./resources/slot/break-away-max.png'),
  CashBlitz: require('./resources/slot/cash-blitzslot.png'),
  PongpongMahjong: require('./resources/slot/pong-pong-mahjong.png'),
  QueenCairo: require('./resources/slot/queen-cairoslot.png'),
  GoldBlitzExtreme: require('./resources/slot/Gold-Blitz-Extreme.png'),
  GoldFireRoseJoker: require('./resources/slot/Fire-Roses-Joker.png'),
  AncientFortunesZeus: require('./resources/slot/Ancient-Fortunes-Zeus.webp'),
  GoldBlitz: require('./resources/slot/Gold-Blitz.jpeg'),
  WildfireWinsExtreme: require('./resources/slot/Wildfire-Wins-Extreme.jpeg'),
  TigerIcePortrait: require('./resources/slot/tiger-s-ice-portrait.jpg'),
  BisonMoon: require('./resources/slot/Bison-Moon.webp'),
  SugarCrazeBonanza: require('./resources/slot/SugarCrazeBonanza.jpg'),
  LuckyTwin: require('./resources/slot/lucky-twin.png'),
  FootballStarDeluxe: require('./resources/slot/FootballStarDeluxe.jpeg'),
  BasketballStaronFire: require('./resources/slot/BasketballStaronFire.jpeg'),
  SuperBIGBuildUp: require('./resources/slot/777-super-big-buildup-deluxe-portrait.webp'),
  WolfBlazeMegaways: require('./resources/slot/wolf-blaze-megaways-portrait.webp'),
  WildfireWins: require('./resources/slot/wildfire-wins-portrait.webp'),
  Wwe: require('./resources/slot/wwe-legends-link-win-portrait-auth.webp'),
  AlmightyZeusWilds: require('./resources/slot/Almighty-Zeus-Wilds.webp'),
  AlmightyZeusEmpire: require('./resources/slot/Almighty-Zeus-Empire.png'),
  CandyRushWilds: require('./resources/slot/candy-rush-wilds.jpg'),
  FishinPostGold: require('./resources/slot/fishin-pots-of-gold-portrait.webp'),

  RomeFightForGoldPortrait: require('./resources/slot/rome-fight-for-gold-portrait.webp'),
  WildCatchSlotFreePlay: require('./resources/slot/Wild-Catch-Slot-Free-Play.png'),
  GalloGoldBruno: require('./resources/slot/gallo-gold-bruno-s-megaways-portrait-auth.webp'),
  MaskOfAmun: require('./resources/slot/mask-of-amun-portrait.webp'),
  CatClans: require('./resources/slot/Cat-Clans.avif'),
  ThunderstruckWildLighting: require('./resources/slot/thunderstruckwildlightning-card_full-a38cf66d.jpg'),
  MastersofOlympus: require('./resources/slot/masters-of-olympus-portrait.webp'),
  MasterOfValhalla: require('./resources/slot/master-of-valhalla.jpeg'),
  ChilliPepeHotStacks: require('./resources/slot/Chilli-Pepe-Hot-Stacks.jpeg'),
  AmazonLostGold: require('./resources/slot/Amazon-Lost-Gold.jpeg'),
  AncientFortunesPoseidonMegaways: require('./resources/slot/ancient-fortunes-poseidon-wowpot-megaways-portrait.jpg'),
  ReelGemsDeluxe: require('./resources/slot/Reel-Gems-Deluxe.jpeg'),
  NoImage: require('./resources/slot/no-image.png'),
  FishOne: require('./resources/slot/fishing_01.png'),
  FishTwo: require('./resources/slot/fishing.png'),

  cards_0: require('./resources/cards/diamonds-1.png'),
  cards_1: require('./resources/cards/clubs-1.png'),
  cards_2: require('./resources/cards/hearts-1.png'),
  cards_3: require('./resources/cards/spades-1.png'),

  cards_4: require('./resources/cards/diamond-2.png'),
  cards_5: require('./resources/cards/clubs-2.png'),
  cards_6: require('./resources/cards/hearts-2.png'),
  cards_7: require('./resources/cards/spades-2.png'),

  cards_8: require('./resources/cards/diamonds-3.png'),
  cards_9: require('./resources/cards/clubs-3.png'),
  cards_10: require('./resources/cards/hearts-3.png'),
  cards_11: require('./resources/cards/spades-3.png'),

  cards_12: require('./resources/cards/diamonds-4.png'),
  cards_13: require('./resources/cards/clubs-4.png'),
  cards_14: require('./resources/cards/hearts-4.png'),
  cards_15: require('./resources/cards/spades-4.png'),

  cards_16: require('./resources/cards/diamonds-5.png'),
  cards_17: require('./resources/cards/clubs-5.png'),
  cards_18: require('./resources/cards/hearts-5.png'),
  cards_19: require('./resources/cards/spades-5.png'),

  cards_20: require('./resources/cards/diamonds-6.png'),
  cards_21: require('./resources/cards/clubs-6.png'),
  cards_22: require('./resources/cards/hearts-6.png'),
  cards_23: require('./resources/cards/spades-6.png'),

  cards_24: require('./resources/cards/diamonds-7.png'),
  cards_25: require('./resources/cards/clubs-7.png'),
  cards_26: require('./resources/cards/hearts-7.png'),
  cards_27: require('./resources/cards/spades-7.png'),

  cards_28: require('./resources/cards/diamonds-8.png'),
  cards_29: require('./resources/cards/clubs-8.png'),
  cards_30: require('./resources/cards/hearts-8.png'),
  cards_31: require('./resources/cards/spades-8.png'),

  cards_32: require('./resources/cards/diamonds-9.png'),
  cards_33: require('./resources/cards/clubs-9.png'),
  cards_34: require('./resources/cards/hearts-9.png'),
  cards_35: require('./resources/cards/spades-9.png'),

  cards_36: require('./resources/cards/diamonds-10.png'),
  cards_37: require('./resources/cards/clubs-10.png'),
  cards_38: require('./resources/cards/hearts-10.png'),
  cards_39: require('./resources/cards/spades-10.png'),

  cards_40: require('./resources/cards/diamonds-11.png'),
  cards_41: require('./resources/cards/clubs-11.png'),
  cards_42: require('./resources/cards/hearts-11.png'),
  cards_43: require('./resources/cards/spades-11.png'),

  cards_44: require('./resources/cards/diamonds-12.png'),
  cards_45: require('./resources/cards/clubs-12.png'),
  cards_46: require('./resources/cards/hearts-12.png'),
  cards_47: require('./resources/cards/spades-12.png'),

  cards_48: require('./resources/cards/diamonds-13.png'),
  cards_49: require('./resources/cards/clubs-13.png'),
  cards_50: require('./resources/cards/hearts-13.png'),
  cards_51: require('./resources/cards/spades-13.png'),
};
export default ImageAssets;
